import { useRef } from "react";
import { Image, Flex, Box, Spinner } from "@chakra-ui/react";
import Fullscreen from "./Fullscreen";
import Fade from "src/components/Fade";

export default function CapturedSnapshot({ src, onClose }) {
  const imageRef = useRef();

  async function openInFullscreen() {
    if (!imageRef.current) return;
    try {
      if (window.document.fullscreenElement) {
        await window.document.exitFullscreen();
        return;
      }
      await imageRef.current.requestFullscreen();
    } catch (err) {
      onClose();
    }
  }

  return (
    <Box position="relative" width="100%" height="100%">
      {!src && (
        <Flex
          onClick={onClose}
          alignItems="center"
          justifyContent="center"
          top="0"
          left="0"
          width="100%"
          height="100%"
          position="fixed"
        >
          <Spinner />
        </Flex>
      )}
      <Flex
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
      >
        <Fade
          in={Boolean(src)}
          duration={{
            enter: 0.3,
            exit: 0
          }}
        >
          <Image ref={imageRef} src={src} maxWidth="100%" maxHeight="90vh" />
        </Fade>
      </Flex>
      <Box
        position="absolute"
        bottom="0"
        right="0"
        width="100%"
        height="20vh"
        backgroundImage="linear-gradient(to bottom,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.6))"
      />
      <Fullscreen onClick={openInFullscreen} />
    </Box>
  );
}
